function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.363 19.733h40.175a2.358 2.358 0 012.364 2.363V46.91a2.358 2.358 0 01-2.364 2.364H5.363A2.358 2.358 0 013 46.91V22.096a2.358 2.358 0 012.363-2.363z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41.403,
  cy: 42.184,
  r: 1.772
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.908 49.273h4.727v4.726H8.908zM37.267 49.273h4.726v4.726h-4.726zM47.902 23.278h4.726v2.954h-4.726z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M22.604 6.735c3.974.09 13.482 1.772 10.306 5.998v7H11.641v-7.27c-2.733-5.137 6.84-5.822 10.963-5.728z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.23,
  cy: 15.597,
  r: 0.591
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.595,
  cy: 10.871,
  r: 0.591
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27.762,
  cy: 11.399,
  r: 0.591
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17.498,
  cy: 15.777,
  r: 0.591
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.854,
  cy: 10.432,
  r: 0.591
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.867 19.733H18.731m6.158-12.76a34.054 34.054 0 014.805-.237c3.974.09 13.482 1.772 10.306 5.998v7h-7.133"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.864,
  cy: 12.052,
  r: 0.591
})));

var SvgToaster = function SvgToaster(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToaster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Toaster.48e60a71.svg";
export { ForwardRef as ReactComponent };